// ==========================================================================
// EGEA Invest - Static site content (derived from public content on egea.ro)
// Dynamic data (products, projects, clients, leads) is served by the API.
// ==========================================================================

const IMG = 'https://egea.ro/images';

export const COMPANY = {
  name: 'EGEA',
  brandLine: 'Invest',
  tagline: 'EGEA Invest · România',
  since: 'EST. 1995',
  phone: '+40 722 410 222',
  phoneHref: 'tel:+40722410222',
  whatsapp: '40722410222',
  location: 'Brazi, Prahova · România',
  email: 'oferte@egea.ro',
  logo: `${IMG}/brand/logo-primary.png`,
  icon: `${IMG}/brand/icon.png`,
};

// The 3 primary product categories that gate the whole site.
// `key` MUST match the campaign category values (auto-login redirect).
export const CATEGORIES = [
  {
    key: 'Schele',
    title: 'Schele',
    subtitle: 'Schele fixe, mobile și turnuri de acces certificate UE.',
    image:
      'https://images.unsplash.com/photo-1616320999187-3c004dad4f0b?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200',
    match: (p) =>
      p.category === 'Schele' ||
      (p.category === 'Scări & Turnuri' && !/pisic/i.test(p.name || '')),
  },
  {
    key: 'Suflători',
    title: 'Răsuflători gaz',
    subtitle: 'Răsuflători pentru rețele de gaz metan, certificate ICECON.',
    image:
      'https://images.unsplash.com/photo-1547186577-a3f4fa07c2ef?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200',
    match: (p) => /gaz|suflăt|răsuflăt/i.test(p.name || '') || p.category === 'Utilități',
  },
  {
    key: 'Scări',
    title: 'Scări',
    subtitle: 'Scări pisică și scări/platforme metalice de acces, zincate conform EN 14122.',
    image:
      'https://images.unsplash.com/photo-1567627829806-b2da346347a0?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200',
    match: (p) => /pisic/i.test(p.name || '') || p.category === 'Scări de acces',
  },
];

const norm = (s) =>
  (s || '')
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .trim();

export const findCategory = (param) =>
  CATEGORIES.find((c) => norm(c.key) === norm(param)) || null;

export const STATS = [
  { value: '30+', label: 'ani · construit în RO' },
  { value: '500+', label: 'proiecte livrate' },
  { value: '48h', label: 'livrare medie' },
  { value: '100%', label: 'certificat UE' },
];

export const CERTIFICATIONS = [
  'EN 12810', 'EN 12811', 'EN 1004', 'EN 13374',
  'EN 14122', 'ISO 9001', 'ISO 14001', 'ISO 45001', 'Certificat UE',
];

export const HOW_IT_WORKS = [
  {
    step: '01',
    title: 'Cere ofertă',
    desc: 'Trimite-ne detaliile proiectului: dimensiuni, cantitate, tip de lucrare.',
  },
  {
    step: '02',
    title: 'Ofertă tehnică < 24h',
    desc: 'Primești un deviz detaliat cu specificații tehnice și timp de livrare într-o zi lucrătoare.',
  },
  {
    step: '03',
    title: 'Producție & montaj',
    desc: 'Producem în fabrica din Brazi, livrăm național și montăm cu echipe autorizate.',
  },
];

export const SERVICES = [
  { title: 'Proiectare', desc: 'Planuri 2D/3D și calcule conform normelor EN.' },
  { title: 'Montaj & demontaj', desc: 'Echipe autorizate, montaj sigur pe orice șantier.' },
  { title: 'Vânzare', desc: 'Stoc constant, livrare în 48h în toată țara.' },
  { title: 'Închiriere', desc: 'Schele fixe și mobile, perioade flexibile.' },
  { title: 'Transport', desc: 'Livrare prin curier, acoperire națională.' },
];
